import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { GlobalCallPanelComponent } from './shared/global-call-panel/global-call-panel.component';
import { ThemeService } from './services/theme.service';
import { CallFacadeService } from './services/call/call-facade.service';
import { CelebrationComponent } from './shared/celebration/celebration.component';
import { StickyNotesButtonComponent } from './shared/sticky-note/sticky-note-button/sticky-notes-button.component';
import { authService } from './services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent, GlobalCallPanelComponent,CelebrationComponent,StickyNotesButtonComponent,CommonModule],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  private calls = inject(CallFacadeService);
  protected auth = inject(authService);  // ← add

  ngOnInit() {

      // Cleanup deprecated localStorage keys
  localStorage.removeItem('pipeline-view-mode');
  localStorage.removeItem('lead-view-mode');
  localStorage.removeItem('refreshToken')

  
    // Only apply theme from localStorage (no API calls)
    this.initializeDefaultTheme();
  }

  /**
   * Initialize default theme from localStorage only
   * User preferences will be applied after login
   */
  private initializeDefaultTheme(): void {
    const storedTheme = localStorage.getItem('user-theme');
    if (storedTheme) {
      this.themeService.applyTheme(storedTheme);
    }
    // If no stored theme, the default theme from ThemeService will be used
  }
}